import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Alert from '@narvar/nth-alert';
import { FormComponentWrapper } from './styles';
import { FormIntro } from './FormIntro';
import { FormContent } from './FormContent';

export const AdditionalOrderForm = ({ twoFaType, onSubmit, errorMessage, errorReset, loading }) => {
  const [orderNumber, setOrderNum] = useState('');
  const [secondFactorInput, setSecondFactorInput] = useState('');
  const [showForm, setShowForm] = useState(false);
  const handleSubmit = () => {
    onSubmit({
      orderNumber,
      secondFactorInput: secondFactorInput ? { [twoFaType]: secondFactorInput } : null,
    });
  };

  const handleChangeTwoFa = (e) => {
    setSecondFactorInput(e.target.value);
  };

  const handleChangeOrder = (e) => {
    setOrderNum(e.target.value);
  };

  // Keeping this off for now until we've decided
  // if we want to handle 2fa
  const showTwoFa = false;

  return (
    <React.Fragment>
      <FormComponentWrapper>
        {showForm ? (
          <FormContent
            {...{
              showTwoFa,
              handleChangeTwoFa,
              secondFactorInput,
              twoFaType,
              handleChangeOrder,
              orderNumber,
              handleSubmit,
              loading,
            }}
          />
        ) : (
          <FormIntro
            onClick={() => {
              setShowForm(!showForm);
            }}
            loading={loading}
          />
        )}
      </FormComponentWrapper>
      {errorMessage && (
        <Alert show={Boolean(errorMessage)} dismissible dismissOnClick={errorReset}>
          <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
        </Alert>
      )}
    </React.Fragment>
  );
};

AdditionalOrderForm.defaultProps = {
  errorMessage: '',
  loading: false,
};

AdditionalOrderForm.propTypes = {
  twoFaType: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  errorReset: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
